<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { ValidationButton, ShipIndex } from '@haskoning/vue-component-library'
import ShipTableHeader from '@/components/ship/ShipTableHeader.vue'
import ShipAPITableRow from '@/components/ship-importer/ShipAPITableRow.vue'

import type { ShipAPIType } from '@/stores/type/shipAPI.type'

import { useShipAPIStore } from '@/stores/shipAPI'
import { useShipStore } from '@/stores/ship'

const shipStore = useShipStore()
const shipAPIStore = useShipAPIStore()
const { writeLoading } = storeToRefs(shipStore)
const {
  items: ships,
  fetchLoading: shipLoading,
  createUpdateDialog,
  currentItem,
  selectedItems,
  validationStatus
} = storeToRefs(shipAPIStore)

async function addShip(): Promise<void> {
  await shipStore.bulkCreateShip(selectedItems.value)
  shipAPIStore.clearSelectedItems()
  shipAPIStore.closeCreateUpdateDialog()
}

const validation = computed({
  get() {
    return validationStatus.value
  },
  set(value) {
    shipAPIStore.setValidationStatus(value)
    shipAPIStore.fetchShipItems()
    selectedItems.value = []
  }
})

const setCurrentItem = (item: ShipAPIType) => {
  shipAPIStore.setCurrentItem(item)
}

const headers = [
  { title: '' },
  { title: 'Name' },
  { title: 'Length overall [m]' },
  { title: 'Breadth/beam' },
  { title: 'Main propulsion power' },
  { title: 'Rudder' },
  { title: 'Main propeller' },
  { title: 'Transverse thruster power' },
  { title: 'Transverse thruster' },
  { title: 'Validation' },
  { title: 'Expand' }
]
</script>

<template>
  <v-dialog
    v-model="createUpdateDialog"
    width="99%"
    height="90%"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card class="pa-3 fill-height">
      <v-card-title>
        Import ship
        <ValidationButton class="ml-2" v-model="validation" />
      </v-card-title>
      <ShipIndex
        :currentItem="currentItem"
        :items="ships"
        :selected-items="selectedItems"
        :loading="shipLoading"
        :check-all-disabled="!ships.length"
        :headers="headers"
        :show-plan-view="false"
        @update-selected-items="shipAPIStore.updateSelectedItems"
        height="75vh"
        class="mx-4"
      >
        <template v-slot:table-header>
          <ShipTableHeader :show-validation="true" />
        </template>
        <template v-slot:table-row="{ item }">
          <ShipAPITableRow
            :item="item as ShipAPIType"
            @click-row="setCurrentItem(item as ShipAPIType)"
          ></ShipAPITableRow>
        </template>
      </ShipIndex>
      <v-card-actions class="mt-2">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="writeLoading"
          color="primary"
          class="text-none"
          variant="text"
          @click="shipAPIStore.closeCreateUpdateDialog()"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          class="text-none"
          variant="text"
          :disabled="!selectedItems.length"
          :loading="writeLoading"
          @click="addShip()"
        >
          Import from SHIP
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
